export default "__VITE_ASSET__BSUf9beQ__"